<div class="bk-dialog bk-dialog__event ranch-create-dialog">
	<div class="cm-progress-bullets">
		<span *ngFor="let astep of steps; let i = index">
			<span class="cm-progress-bullets__bullet"
				[ngStyle]="{color: i > currentStepIndex ? COLORS.GREY_LIGHT : COLORS.GREY}">
				&bull;
			</span>
		</span>
	</div>
	<h4 mat-dialog-title>
		{{ 'Create' | translate }} {{ 'Ranch' | translate }}
	</h4>

	<ng-container *ngIf="currentStep.Id === STEPS.RanchDetails">
		<ranch-create-basic-step
			[form]="f.RanchDetails"
			(ranchDetailsForm)="setRanchDetailsForm($event)"
			(onCancel)="close()"
			(nextStep)="nextStep($event)">
		</ranch-create-basic-step>
	</ng-container>

	<ng-container *ngIf="currentStep.Id === STEPS.CommodityTypes">
		<ranch-create-commodity-types-step
			[form]="f.CommodityTypes"
			[subscriptions$]="subscriptions$"
			(onBack)="back()"
			(onCancel)="close()"
			(nextStep)="nextStep($event)">
		</ranch-create-commodity-types-step>
	</ng-container>

	<ng-container *ngIf="currentStep.Id === STEPS.WeatherStations">
		<ranch-create-weather-stations-step
			[form]="f.WeatherStations"
			[ranchCoordinates]="ranchCoordinates"
			[subscriptions$]="subscriptions$"
			(onBack)="back()"
			(onCancel)="close()"
			(nextStep)="nextStep($event)">
		</ranch-create-weather-stations-step>
	</ng-container>

	<ng-container *ngIf="currentStep.Id === STEPS.Fertilizers">
		<ranch-create-fertilizers-step
			[form]="f.Fertilizers"
			[subscriptions$]="subscriptions$"
			(onBack)="back()"
			(onCancel)="close()"
			(nextStep)="nextStep($event)">
		</ranch-create-fertilizers-step>
	</ng-container>

	<ng-container *ngIf="currentStep.Id === STEPS.Wells">
		<ranch-create-wells-step
			[form]="f.Wells"
			[subscriptions$]="subscriptions$"
			(onBack)="back()"
			(onCancel)="close()"
			(nextStep)="nextStep($event)">
		</ranch-create-wells-step>
	</ng-container>

	<ng-container *ngIf="currentStep.Id === STEPS.PlantingAreas">
		<ranch-create-planting-areas-step
			[form]="f.PlantingAreas"
			[ranchCoordinates]="ranchCoordinates"
			[isSaving]="isSaving"
			[subscriptions$]="subscriptions$"
			(onBack)="back()"
			(onCancel)="close()"
			(onSubmit)="finish()">
		</ranch-create-planting-areas-step>
	</ng-container>
</div>
